import { Link } from "@mui/material";
import CTypography from "./CTypography";

export function Copyright(props: any) {
  return (
    <CTypography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="/">
        Laundry Xpress
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </CTypography>
  );
}
